module.exports = new __parcel__URL__("Brickfilms.22167702.webp").toString();